import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, ElementRef, ViewChild, AfterViewInit, Input, DoCheck, HostListener, SimpleChanges, OnInit } from '@angular/core';
import { fabric } from 'fabric';

@Component({
  selector: 'calsoft-product-customizer',
  templateUrl: './product-customizer.component.html',
  styleUrls: ['./product-customizer.component.scss']
})
export class ProductCustomizerComponent implements AfterViewInit{

  ngOnChanges(changes: SimpleChanges) {
    if (changes['image'] && !changes['image'].firstChange) {
      // Ensure the canvas is ready before loading the new image
      if (this.canvas) {
        this.loadImageToCanvas();
      }
    }
  }
  @ViewChild('tshirtCanvas', { static: true }) canvasElement: ElementRef<HTMLCanvasElement>;
  canvas: fabric.Canvas;
  textInput: string = '';
  textColor: string = '#000000'; // Default text color
  @Input() image: any;
  @Input() zoomImage: any;
  @Input() productIdAddedInCart: any={};
  @Input() imageList:any;
  @Input()  data: any;
  @Input()  product: any;
  @Input()  productDetailHeightMobile: any;
  @Input()  productDetailWidthMobile: any;
  @Input()  productDetailHeight: any;
  @Input()  productDetailWidth: any;
  @Input()  name: any;
  @Input()  ProductType : any;
  @Input()  configProductSelected : any;
  @Input() coversionTrackingIdGa: any;
  @Input() productCustomOption: any;
  @Input()  configattributeType:any;
  @Input() productOption: any[];
  @Input() configproduct: any = [];
  isCustomizerOpen = false;
  toggleCustomizer() {
    this.isCustomizerOpen = !this.isCustomizerOpen;
  }
  @HostListener('document:click', ['$event'])
  clickOutside(event: any) {
    if (this.isCustomizerOpen && !this.eRef.nativeElement.contains(event.target)) {
      this.isCustomizerOpen = false;
    }
  }
  constructor(private eRef: ElementRef,private breakpointObserver: BreakpointObserver) {}



  isSmallScreen = false;



  ngAfterViewInit() {
    // Listen for screen size changes and adjust the canvas size
    this.breakpointObserver.observe([Breakpoints.XSmall]).subscribe(result => {
      if (result.matches) {
        // On small screens, reduce the canvas size
        this.isSmallScreen = true;
        this.initCanvas(300, 300);  // Example size for small screens
      } else {
        // For larger screens, use default canvas size
        this.isSmallScreen = false;
        this.initCanvas(800, 800);  // Default size
      }
    });
    this.canvas.on('mouse:dblclick', (e) => {
      const activeObject = this.canvas.getActiveObject();
      if (activeObject && activeObject.type === 'textbox') {
        activeObject.enterEditing();
        activeObject.selectAll();
      }
    });
    this.canvas.on('text:editing:entered', (e) => {
      const activeObject = e.target;
      if (activeObject && activeObject.type === 'textbox') {
        this.canvas.on('text:editing:exited', () => {
          this.canvas.off('text:editing:exited'); // Clean up event listener
        });
      }
    });
  }

  initCanvas(width: number, height: number) {
    if (this.canvas) {
      this.canvas.dispose();  // Clean up previous canvas
    }

    this.canvas = new fabric.Canvas(this.canvasElement.nativeElement, {
      width: width,
      height: height,
    });

    // Load the T-shirt image initially if available
    this.loadImageToCanvas();

    this.saveState();  // Save the initial canvas state
  }

  loadImageToCanvas() {
    if (this.image) {
      fabric.Image.fromURL(this.image, (img) => {
        const canvasWidth = this.canvas.width!;
        const canvasHeight = this.canvas.height!;
  
        const scaleX = canvasWidth / img.width!;
        const scaleY = canvasHeight / img.height!;
        const scaleFactor = Math.min(scaleX, scaleY);
  
        img.set({
          scaleX: scaleFactor,
          scaleY: scaleFactor,
          originX: 'center',
          originY: 'center',
          left: canvasWidth / 2,
          top: canvasHeight / 2,
        });
  
        this.canvas.setBackgroundImage(img, this.canvas.renderAll.bind(this.canvas));
        this.canvas.renderAll(); // Ensure rendering
      }, { crossOrigin: 'anonymous' }); // Fix potential CORS issue
    }
  }
  




  loadState(state: string) {
    this.canvas.loadFromJSON(state, this.canvas.renderAll.bind(this.canvas));
  }
  history: string[] = [];
  redoHistory: string[] = [];
  historyIndex: number = -1;
  

  onImageUpload(event: any) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        fabric.Image.fromURL(e.target.result, (img) => {
          img.scaleToWidth(100); // Set initial image size
          img.scaleToHeight(100);
          const canvasWidth = this.canvas.getWidth();
          const canvasHeight = this.canvas.getHeight();
          // Use Fabric.js center method to center the image
          img.set({
            originX: 'center',
            originY: 'center'
          });

          // Center the image based on current canvas size
          img.set({
            left: this.canvas.getWidth() / 2,
            top: this.canvas.getHeight() / 2
          });
          this.canvas.add(img);
          this.canvas.setActiveObject(img);
          this.canvas.renderAll();
        });
      };
      reader.readAsDataURL(file);
    }
  }

  @HostListener('window:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const activeObject = this.canvas.getActiveObject();
  
    // Check if there's an active object and it's a fabric.Textbox
    if (activeObject) {
      const isTextbox = activeObject.type === 'textbox';
      const isEditing = isTextbox && (activeObject as fabric.Textbox).isEditing;
  
      // If it's a textbox and in editing mode, let the default behavior handle text editing
      if (isEditing) {
        // Allow text editing keys to work, including Backspace
        return;
      }
  
      // For non-editing mode text boxes or other objects
      let movementAmount = 10; // Amount of movement for each key press
      switch (event.key) {
        case 'Delete':
        case 'Del':
        case 'Backspace':
          this.deleteSelectedItem();
          break;
        // case 'Backspace':
        //   if (!isTextbox) {
        //     this.deleteSelectedItem();
        //   }
        //   break;
        case 'ArrowUp':
          activeObject.top! -= movementAmount;
          break;
        case 'ArrowDown':
          activeObject.top! += movementAmount;
          break;
        case 'ArrowLeft':
          activeObject.left! -= movementAmount;
          break;
        case 'ArrowRight':
          activeObject.left! += movementAmount;
          break;
        default:
          return; // Ignore other keys
      }
      activeObject.setCoords(); // Updates object's bounding box
      this.canvas.renderAll();
      event.preventDefault();
    }
  }
  
  

  onGifUpload(event: any) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        fabric.Image.fromURL(e.target.result, (gif) => {
          gif.scaleToWidth(100); // Set initial GIF size
          gif.scaleToHeight(100);
          this.canvas.add(gif);
          this.canvas.setActiveObject(gif);
          this.canvas.renderAll();
        });
      };
      reader.readAsDataURL(file);
    }
  }
  undoStack: fabric.Object[] = [];
redoStack: fabric.Object[] = [];

// Save state on every action
saveState() {
  this.undoStack.push(this.canvas.toJSON());
}

undo() {
  if (this.undoStack.length > 0) {
    const prevState = this.undoStack.pop();
    this.canvas.loadFromJSON(prevState, () => this.canvas.renderAll());
    this.redoStack.push(prevState);
  }
}

redo() {
  if (this.redoStack.length > 0) {
    const nextState = this.redoStack.pop();
    this.canvas.loadFromJSON(nextState, () => this.canvas.renderAll());
  }
}

  selectedFontFamily: string = 'Arial'; 
  changeFontFamily() {
    const activeObject = this.canvas.getActiveObject() as fabric.Text;
    if (activeObject && activeObject.type === 'textbox') {
      activeObject.set('fontFamily', this.selectedFontFamily);
      this.canvas.renderAll();
    }
  }
  savedCanvasData: any; 

    saveCanvas() {
      const canvasData = this.canvas.toJSON();
      this.savedCanvasData = canvasData; 
      if ((this.configproduct.type == 'Configurable'
|| this.configproduct.type == 'Variants')
&& this.configproduct.configurableProductDropdown != null) {
if (this.configproduct.entityId != this.product.entityId) {
  localStorage.setItem('savedCanvasImageData'+ this.configproduct.entityId, canvasData);
}else{
  localStorage.setItem('savedCanvasImageData'+ this.product.entityId, canvasData);
}
}else{
  localStorage.setItem('savedCanvasImageData'+ this.product.entityId, canvasData);
}
    }
  
    downloadCanvas() {
      if (this.image) {
        // Ensure the canvas is rendered before downloading
        this.canvas.renderAll();
    
        const dataURL = this.canvas.toDataURL({
          format: 'png', 
          quality: 1,    
          multiplier: 2 
        });

 // Store the full dataURL (including the format) in local storage
// Concatenate the dataURL and product.entityId with a delimiter
const combinedData = `${dataURL}`;

// Store the combined data in localStorage

if ((this.configproduct.type == 'Configurable'
|| this.configproduct.type == 'Variants')
&& this.configproduct.configurableProductDropdown != null) {
if (this.configproduct.entityId != this.product.entityId) {
  localStorage.setItem('savedCanvasImageData'+ this.configproduct.entityId, combinedData);
}else{
  localStorage.setItem('savedCanvasImageData'+ this.product.entityId, combinedData);
}
}else{
  localStorage.setItem('savedCanvasImageData'+ this.product.entityId, combinedData);
}

        // Create a link element to trigger the download
        const link = document.createElement('a');
        link.href = combinedData;
        link.download = 'custom-tshirt.png';
    
        // Append the link, trigger the download, and then remove the link
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        console.error('No image is loaded onto the canvas.');
      }
    }
    
  
   
    addText() {
      if (this.textInput.trim()) {
        const text = new fabric.Textbox(this.textInput, {
          fontSize: 20,
          fill: this.textColor,
          originX: 'center',  // Center horizontally
          originY: 'center'
        });
        // Center the text based on current canvas size
        text.set({
          left: this.canvas.getWidth() / 2,
          top: this.canvas.getHeight() / 2
        });
  
        this.canvas.add(text).setActiveObject(text);
        this.canvas.renderAll();
        this.textInput = '';
      }
    }
    

  
  changeTextColor() {
    const activeObject = this.canvas.getActiveObject() as fabric.Text;
    if (activeObject && activeObject.type === 'textbox') {
      activeObject.set('fill', this.textColor);
      this.canvas.renderAll();
    }
  }
  

  onBrightnessChange(event: any) {
    const brightness = parseFloat(event.target.value);
    this.applyFilter('brightness', brightness);
  }
  
  onSaturationChange(event: any) {
    const saturation = parseFloat(event.target.value);
    this.applyFilter('saturation', saturation);
  }
  
  onOpacityChange(event: any) {
    const opacity = parseFloat(event.target.value);
    const activeObject = this.canvas.getActiveObject();
    if (activeObject) {
      activeObject.set('opacity', opacity);
      this.canvas.renderAll();
    }
  }
 
  
  applyFilter(filterType: string, value: number) {
    const activeObject = this.canvas.getActiveObject() as fabric.Image;
  
    if (activeObject && activeObject.type === 'image') {
      switch (filterType) {
        case 'brightness':
          activeObject.filters.push(new fabric.Image.filters.Brightness({ brightness: value }));
          break;
        case 'contrast':
          activeObject.filters.push(new fabric.Image.filters.Contrast({ contrast: value }));
          break;
        case 'saturation':
          activeObject.filters.push(new fabric.Image.filters.Saturation({ saturation: value }));
          break;
        case 'opacity':
          activeObject.set('opacity', value);
          break;
        default:
          // Handle other filter types or clear filters
          break;
      }
  
      activeObject.applyFilters();
      this.canvas.renderAll();
    }
  }
  
  


  deleteSelectedItem() {
    const activeObject = this.canvas.getActiveObject();
    
    if (activeObject) {
      this.canvas.remove(activeObject); // Remove the object from the canvas
      
      // Check if the object was actually removed
      if (this.canvas.getActiveObject() === activeObject) {
        console.error('Failed to remove the active object from the canvas.');
      }
  
      this.canvas.discardActiveObject(); // Ensure no object remains selected
      this.canvas.renderAll(); // Re-render the canvas
    } else {
      console.warn('No active object to delete.');
    }
  }
  
}
